import { sleep } from '@/shared/helpers';

export interface IusePollWithRetryOptions {
  retries?: number;
  delay?: number;
  silent?: boolean;
  onFinalFail?: () => void;
}
export async function usePollWithRetry<T>(
  fn: () => Promise<T | false>,
  {
    retries = 2,
    delay = 5000,
    silent = true,
    onFinalFail,
  }: IusePollWithRetryOptions = {}
): Promise<T | false> {
  let attempt = 0;

  while (attempt <= retries) {
    try {
      const result: any = await fn();

      if (result?.status) return result;

      attempt++;
      if (attempt > retries) break;
    } catch (e) {
      attempt++;
      if (!silent) console.error(e);
      if (attempt > retries) break;
    }

    await sleep(delay, true);
  }

  onFinalFail?.();
  return false;
}
